// export const API_URL = 'http://localhost:3000/api';

// export const API_URL = 'https://sundek.visualinteraction.systems/api';

export const API_URL = 'https://srcalendar.sundekapp.com/api';
